export default "__VITE_ASSET__BCIfs6Ed__"